import { useEffect } from 'react';
import { startCursorOverlayNeutralize } from './neutralize-cursor-overlay';

/** App-wide guard so dashboard/settings/etc. stay clickable in Cursor browser. */
export default function CursorOverlayGuard(): null {
  useEffect(() => startCursorOverlayNeutralize(), []);
  return null;
}
